import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
    card: {
        marginTop: '1rem',
        position: 'relative'
    },
    overlay: {
        width: '100%',
        position: 'absolute',
        top: '40%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        color: '#fff',
        fontWeight: 'bolder'
    }
})

export default useStyles